import { useState } from 'react';
import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';

interface MoveUserDialogProps {
    userLogin: string;
    targetNodeName: string;
    open: boolean;
    onClose: () => void;
    onConfirm: () => Promise<void>;
}

const MoveUserDialog = ({ userLogin, targetNodeName, open, onClose, onConfirm }: MoveUserDialogProps) => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const handleClose = () => {
        if (loading) return;
        setError('');
        onClose();
    };

    const handleConfirm = async () => {
        setLoading(true);
        setError('');
        try {
            await onConfirm();
        } catch {
            setError('Не удалось перенести пользователя');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            onKeyDown={(e) => { if (e.key === 'Enter' && !loading) handleConfirm(); }}
        >
            <DialogTitle>Перенести пользователя</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    Вы уверены, что хотите перенести пользователя «{userLogin}» в «{targetNodeName}»?
                </DialogContentText>
                {error && <DialogContentText color="error" sx={{ mt: 1 }}>{error}</DialogContentText>}
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} disabled={loading}>Отмена</Button>
                <Button onClick={handleConfirm} variant="contained" disabled={loading} disableElevation autoFocus>
                    {loading ? <CircularProgress size={18} /> : 'Перенести'}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default MoveUserDialog;
